/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse_PropertyRequestReceipt_ } from '../models/ControllerResponse_PropertyRequestReceipt_';
import type { PropertyRequestBody } from '../models/PropertyRequestBody';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PropertyRequestsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Submit a missing property for the data pipeline to process.
     * @param requestBody
     * @returns ControllerResponse_PropertyRequestReceipt_ Created
     * @throws ApiError
     */
    public submitPropertyRequest(
        requestBody: PropertyRequestBody,
    ): CancelablePromise<ControllerResponse_PropertyRequestReceipt_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/property-requests',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
